export const FunctionIconTestIds = {
  FUNCTION_ICON: 'function-icon.icon',
};
